import React from "react";

const Mission = () => {
  return (
    <section className="w-full overflow-hidden">
      <img
        src="/images/mission.webp"
        alt="Mission"
        loading="lazy"
        className="
          w-full
          h-auto
          block
        "
      />

      
    </section>
  );
};

export default Mission;